import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import store from './store'
import VueFriendlyIframe from 'vue-friendly-iframe';
import router from "./router";


Vue.config.productionTip = false
Vue.use(VueFriendlyIframe);


new Vue({
  vuetify,
  router,
  store,
  render: h => h(App)
}).$mount('#app')
